
import React from "react";
import "./rightbarhome.scss";
import actividadesAd from '../../assets/ads/actividades.png';
import YaleAd from '../../assets/ads/yalemas.jpeg';
import People from '../../assets/ads/people.png';
import vivebien from '../../assets/ads/vivebien.png';
import mana from '../../assets/ads/mana.png';
import mundialAd from '../../assets/ads/mundial.png';


const Rightbarhome = () => {
  return (
    <div className="rightbarhome">

      <div className="birthdayContainer"></div>

      <a href="https://assa.pasiongolcompensar.com/" target="_blank" rel="noreferrer">
        <img src={mundialAd} alt="Pasión Gol Compensar" className="rightbarAdvert rightbarAdvertLarge" />
      </a>
      <a href="https://assaabloy.sharepoint.com/sites/AMER-ASSAABLOYCOLOMBIA/_layouts/15/Events.aspx?ListGuid=567e0302-9a94-4da8-8043-51d7e77b4e66">
        <img src={actividadesAd} alt="" className="rightbarAdvert rightbarAdvertLarge" />
      </a>
      <a href="https://www.yalehome.com.co/">
        <img src={YaleAd} alt="" className="rightbarAdvert rightbarAdvertLarge" />
      </a>
      <a href="https://wa.me/573102052760?text=Hola%20SAC%20PeoplePass%20PayCash%2C%20quiero%20mas%20informacion" target="_blank" rel="noreferrer">
        <img src={People} alt="SAC PeoplePass PayCash" className="rightbarAdvert rightbarAdvertPeople" />
      </a>
      <a href="https://corporativo.compensar.com/salud/plan-de-beneficios-en-salud/compensar-eps/vive-bien">
        <img src={vivebien} alt="" className="rightbarAdvert rightbarAdvertLarge" />
      </a>
      <a href="https://corporativo.compensar.com/salud/c-mana-saludable">
        <img src={mana} alt="" className="rightbarAdvert rightbarAdvertLarge" />
      </a>
    </div>
  );
};

export default Rightbarhome;
